<template>
  <div class="neanderthals">
    <Search :title="name" :total="neanderthal_proportion">
      <van-tabs v-model="activeTab">
        <van-tab title="评估项目">
          <div style="background: #fff">
            <img class="svg" src="../../assets/images/source/neanderthals.png" alt="尼安德特人">
          </div>
          <div class="detail_box" v-if="items">
            <p class="title">受影响的健康风险</p>
            <div class="details" v-for="(item, index) in items" :key="index">
              <div>
                <span class="dot"></span>
                <span style="margin-left: 0.05rem">
                  <span>{{item.chname}}</span>
                  <span style="float: right" :class="item.tag === 0 ? '' : 'red'">{{item.effect}}</span>
                </span>
              </div>
              <div style="margin-left: 0.1rem">
                <div class="flex">
                  <div>
                    <p>基因</p>
                    <p>{{item.gene_name}}</p>
                  </div>
                  <div>
                    <p>位点</p>
                    <p>{{item.rs}}</p>
                  </div>
                  <div>
                    <p>基因型</p>
                    <p>{{item.genotype}}</p>
                  </div>
                </div>
                <p>项目简介：{{item.desc}}</p>
              </div>
            </div>
          </div>
          <div class="detail_box" v-else>
            <p class="title">个人数据未覆盖评估项目位点，暂无评估结果。</p>
          </div>
        </van-tab>
        <van-tab title="参考文献">
          <Paper :data="references"></Paper>
        </van-tab>
        <van-tab title="小贴士">
          <p class="tips">
            现代人，即在生物学上的智人，是人属动物仅存的一种。而在人类的进化进程中，还有与人同科、同属的其他物种出现过，比如尼安德特人（Nineanderthals）， 北京猿人（Pekingman），丹尼索瓦人 (Denisovans) 等，如今都已经灭绝了。尼安德特人，其化石发现于德国尼安德特山谷而得名。与现代人类在 60~70 万年前有着共同的祖先，有的人类学家将他们看作智人的一个亚种。
            <img style="width: 80%" src="../../assets/images/source/u120.png" alt="图一">
            尼安德特人头大、前额低、五官更加突出但下巴不明显，与现代智人相比他们肩膀更宽、身体粗壮，四肢粗短，身高平均约 1.65 米，体型较现代人更显得矮胖，但比现代人强壮的多。
            大约 60 万年前，尼安德特人从非洲的早期人种中分离出来，向北迁移到西亚和欧洲。当时的欧洲大部分区域都被冰雪覆盖、自然条件恶劣，而尼安德特人体型特征使其更适合在寒冷地区生存。
            <img style="width: 60%" src="../../assets/images/source/u121.png" alt="图二">
            6 万年前，智人离开非洲大陆，在西亚遇到了尼安德特人，和尼安德特人共存了一段时间。到 4 万年前，尼安德特人灭绝了。
            关于尼安德特人灭绝的原因，有研究者分析可能是尼安德特人与智人之间的人数、生存能力以及文化的代差，智人具有绝对的优势。当然，气候环境的变化、突发性的灾难、基因多样性减少导致缺陷增加，都可能最终导致整个种群的灭绝。
            事实上，尼安德特人并未完全消失。目前除非洲撒哈拉沙漠以南的人外，亚洲人、欧洲人等均携带尼安德特人的基因。这证明，尼安德特人与走出非洲的人类远祖曾经进行过交配并生下了可繁殖的后代，这也是为什么绝大多数非洲人没有尼安德特人的基因。随着“高质量”尼安德特人基因组的公布，有研究发现东亚人体内的尼安德特人 DNA 最多，大约有2.3% 到 2.6%；而西亚和欧洲人则仅有1.8% 到 2.4%。这些尼安德特人的基因能够在经历这么长的时间后，依然留存在现代人的基因库中，说明他们曾经让我们受益。比如，在欧洲或亚洲长时间演化的尼安德特人基因使我们的祖先更适应当时当地的气候。
            <img style="width: 60%" src="../../assets/images/source/u122.png" alt="图三">
            然而尼安德特人的一些基因对现代人来说也可能会产生负面影响，比如血液容易凝固对尼安德特人来讲，可以使他们更好的适应当时的生存环境，但会使现代人更容易患上心脏病和中风。同样，尼安德特人基因对免疫系统和皮肤的影响放在今天，可能更容易引发自身免疫性疾病。2016 年《科学》发表的文章认为尼安德特人的基因给我们带来一系列的健康问题，如抑郁症、尼古丁成瘾、营养失衡、尿失禁、膀胱疼痛等；《自然》也发表过文章，认为我们从尼安德特人上获得的基因，导致了现代人患二型糖尿病的概率增加。《美国人类遗传学》发布的研究论文表示，来自于阿尔泰山的尼安德特人 DNA 给现代人类所带来的影响还有对阳光的反应，包括晒黑的难易度、头发的颜色、睡觉的习惯等。
          </p>
        </van-tab>
      </van-tabs>
    </Search>
  </div>
</template>

<script>
import Search from '@/components/Search'
import Paper from '@/components/Paper'
export default {
  name: 'neanderthals',
  data () {
    return {
      activeTab: 0,
      name: '尼安德特人比例',
      neanderthal_proportion: '',
      items: [],
      references: []
    }
  },
  methods: {
    // 祖源数据概览
    neanderthal () {
      this.util.get(this.api.neanderthal, '', (success) => {
        this.neanderthal_proportion = parseFloat(success.neanderthal_proportion) + '%'
        this.items = success.items
        this.desc = success.desc
        this.references = success.references.map((item, index) => {
          return '[' + (index * 1 + 1) + ']' + item
        })
      })
    }
  },
  mounted () {
    this.neanderthal()
  },
  components: {
    Search,
    Paper
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .neanderthals {
    img {
      display: block;
    }
    .svg {
      width: 50%;
      height: pxToRem(600px);
      margin: 0 auto;
      padding: pxToRem(40px) 0;
    }
    .detail_box {
      margin-top: pxToRem(20px);
      .title {
        font-size: pxToRem(35px);
        padding: pxToRem(20px) pxToRem(20px);
        background: #fff;
      }
      .details {
        font-size: pxToRem(30px);
        background: #fff;
        padding: pxToRem(50px) pxToRem(40px);
        margin: pxToRem(30px) 0;
        .dot {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #00D0FF;
          margin-left: pxToRem(-25px);
        }
        .flex {
          display: flex;
          justify-content: space-between;
          padding: pxToRem(40px) 0;

          div {
            text-align: center;
          }
        }
        .red {
          color: red;
          text-align: right;
        }
      }
    }
    .tips {
      padding: pxToRem(40px);
      line-height: pxToRem(50px);
      img {
        width: 100%;
        margin: pxToRem(20px) auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/source/neanderthals.vue